import React, { useEffect, useState } from "react";
import "./styles.css";
import {
    obtenerPerfilesCreados,
} from "../../services/firebase/perfiles";
import { useToasts } from "react-toast-notifications";


export const Perfiles = () => {
    const [perfilesCreados, setPerfilesCreados] = useState([]);
    const { addToast } = useToasts();

    useEffect(() => {
        const obtenerDatos = async () => {
            try {
                const perfilesData = await obtenerPerfilesCreados();
                setPerfilesCreados(perfilesData);
            } catch (error) {
                console.error("Error al obtener datos de Firebase:", error);
                addToast("Error al cargar perfiles", { appearance: "error" });
            }
        };

        obtenerDatos();
    }, []);

    if (perfilesCreados === null) {
        return <p>Cargando Perfiles...</p>;
    }

    const getPerfilIcon = (perfilName) => {
        const name = (perfilName || "").toUpperCase();
        if (name.includes("ADMINISTRADOR")) return "fas fa-user-shield";
        if (name.includes("ODONTOLOGO")) return "fas fa-user-md";
        if (name.includes("ASISTENTE")) return "fas fa-user-nurse";
        return "fas fa-user"; // Default icon
    };

    return (
        <div className="container-perfiles">
            <div className="perfiles-creados-container">
                <div>
                    <h2>PERFILES EXISTENTES</h2>
                </div>
                <div className="perfiles-map">
                    {perfilesCreados.map((perfil) => (
                        <div key={perfil.id} className="perfil-creado">
                            <div className="perfil-icon-container">
                                <i className={getPerfilIcon(perfil.perfil)} style={{ fontSize: "2rem", color: "#3498db", marginBottom: "10px" }}></i>
                            </div>
                            <p className="nombre-perfil">
                                <span
                                    style={{
                                        fontSize: "1.2rem",
                                        fontWeight: "bold",
                                        color: "#3498db",
                                    }}
                                >
                                    {perfil.perfil}
                                </span>
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
